import * as React from "react";
import { inject, observer } from "mobx-react";
import { MobxComponent } from "../../../../../mobx/components";
import { Button } from "@lib/components";
import { config } from "../../../../../config";
import { UI } from "../../../../../core/ui";

interface Props {
	autoExport?: boolean;
	hideTrigger?: boolean;
	onComplete?: () => void;
}
interface State {
	active: boolean;
}

@inject("store") @observer
export class CSVExport extends MobxComponent<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			active: false,
		};
	}

	componentDidMount() {
		if (this.props.autoExport) {
			this.exportCSV();
		}
	}

	async exportCSV() {
		const { restaurant } = this.injected.store;
		const csvType = '';
		const restaurantId = restaurant!._id;
		const restaurantName = restaurant!.name;
		const apiUrl = `${config.urls.api}/restaurants/menus/export/csv/${restaurantId}?csvType=${csvType}`;
		const authToken = this.injected.store.auth.token;

		try {
			const response = await fetch(apiUrl, {
				method: 'GET',
				headers: {
					'Authorization-Dashboard': `${authToken}`,
				}
			});

			if (!response.ok) {
				throw new Error(`Failed to export CSV. Status: ${response.status}`);
			}

			const blob = await response.blob();
			const url = window.URL.createObjectURL(blob);

			const a = document.createElement('a');
			a.href = url;
			a.download = `${restaurantName}_menu.csv`;
			document.body.appendChild(a);
			a.click();
			a.remove();

			window.URL.revokeObjectURL(url);
			UI.notification.success('Export successful');
		} catch (error: any) {
			UI.notification.error(`Failed to export CSV`);
			console.error('Error exporting CSV:', error);
		}

		if (this.props.onComplete) {
			this.props.onComplete();
		}
	}

	render() {
		if (this.props.hideTrigger) {
			return null;
		}
		return (
			<div className="inline-block">
				<Button size="xxs" color="white" onClick={() => this.exportCSV()}>
					CSV Export
				</Button>
			</div>
		);
	}

}
